import * as React from "react";
const SvgFiRrBuild = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-build_svg__a)">
      <path
        fill="#062147"
        d="M22 10h-7c-1.103 0-2 .897-2 2v4H2c-1.103 0-2 .897-2 2v1.5C0 21.981 2.019 24 4.5 24h15c2.481 0 4.5-2.019 4.5-4.5V12c0-1.103-.897-2-2-2m-7 2h7v4h-7zm1 6v4H8v-4zM2 19.5V18h4v4H4.5A2.503 2.503 0 0 1 2 19.5m20 0c0 1.378-1.121 2.5-2.5 2.5H18v-4h4zM1.397 8.386l4.819 2.81a3.28 3.28 0 0 0 3.152-.223C10.39 10.318 11 9.179 11 7.924V7h2.269A2 2 0 0 0 15 8h5c1.103 0 2-.897 2-2s-.897-2-2-2h-5a2 2 0 0 0-1.731 1H11v-.924c0-1.254-.61-2.394-1.632-3.049C8.417.417 7.239.334 6.13.849L1.414 3.605A2.71 2.71 0 0 0 0 6c0 1 .535 1.912 1.397 2.386m.996-3.037 4.659-2.727c.193-.089.374-.123.538-.123.308 0 .553.119.699.212.445.286.711.796.711 1.365v3.848c0 .569-.266 1.08-.711 1.365-.224.143-.68.345-1.15.135L2.393 6.652l-.029-.017C2.035 6.458 2 6.132 2 6a.72.72 0 0 1 .393-.651"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-build_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBuild;
